





export default {
  name: 'VCount',
  props: {
    count: {
      type: [String, Number]
    },
    prependPlus: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'base'
    }
  },
  computed: {
    getChipText(): string {
      if (!this.count) return '-';

      return this.prependPlus ? `+${this.count}` : this.count;
    }
  }
};
